import $ from 'jquery';
import _ from 'underscore';

const observeInDOM = (el, onAttached, onDetached) => {
  const onAttachedToDOM = _.isFunction(onAttached) ? onAttached : _.noop;
  const onDetachedFromDOM = _.isFunction(onDetached) ? onDetached : _.noop;

  const getEl = () => {
    const $el = _.isString(el) ? $(el) : el;
    return $el.get(0);
  };

  let wasInDOM = $.contains(document.body, getEl());

  const observer = new MutationObserver(() => {
    const inDOM = $.contains(document.body, getEl());

    if (inDOM) {
      if (!wasInDOM) {
        wasInDOM = true;
        onAttachedToDOM();
      }
    } else if (wasInDOM) {
      wasInDOM = false;
      observer.disconnect();

      onDetachedFromDOM();
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
};

export { observeInDOM };
